module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dn-dialog', {
    ref: "dialog",
    attrs: {
      "content-class": "dn-db-manager-dialog",
      "persistent": "",
      "btnClose": false
    }
  }, [_c('h3', {
    staticClass: "my-header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._t("header")], 2), _vm._v(" "), _c('div', {
    staticClass: "my-body"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c375f46","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/manager/DbManager/dialogs/DialogBase.vue
// module id = 437
// module chunks = 1